import {ReportingAnalyticsResponse} from "../../../store/reporting/reporting.common";

/**
 Returns true if report has segments(!) and these segments are empty.
 */
export const hasEmptySegments = (data: ReportingAnalyticsResponse): boolean =>
  data.segments?.length === 0;
